var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-tabs",
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "顶栏菜单" } },
            [
              _c(
                "el-button-group",
                { staticClass: "d2-mb" },
                [
                  _c("el-button", { on: { click: _vm.handleHeaderSet } }, [
                    _vm._v("设置顶栏空菜单")
                  ]),
                  _c("el-button", { on: { click: _vm.headerReset } }, [
                    _vm._v("恢复顶栏菜单")
                  ])
                ],
                1
              ),
              _c("d2-highlight", {
                attrs: { code: JSON.stringify(_vm.header, null, 2) }
              })
            ],
            1
          ),
          _c(
            "el-tab-pane",
            { attrs: { label: "侧栏菜单" } },
            [
              _c(
                "el-button-group",
                { staticClass: "d2-mb" },
                [
                  _c("el-button", { on: { click: _vm.handleAsideSet } }, [
                    _vm._v("设置侧栏空菜单")
                  ]),
                  _c("el-button", { on: { click: _vm.asideReset } }, [
                    _vm._v("恢复侧栏菜单")
                  ]),
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.asideTransitionToggle()
                        }
                      }
                    },
                    [
                      _vm._v(
                        _vm._s(
                          (_vm.asideTransition ? "关闭" : "开启") +
                            "侧栏动画效果"
                        )
                      )
                    ]
                  )
                ],
                1
              ),
              _c("d2-highlight", {
                attrs: { code: JSON.stringify(_vm.aside, null, 2) }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }